'use strict';

export default function f($scope, $window, $element, $timeout, keyCodes, slideshow, alert, photoModel, guideStatus) {
  'ngInject';

  var documentEl = angular.element($window.document);

  this.currentPhotoIndex = this.initialPhotoIndex || 0;
  this.currentPhoto = this.photos[this.currentPhotoIndex];
  this.isGuide = guideStatus.isGuide();

  function keyupHandler(event) {
    $scope.$apply(function () {
      switch (event.which) {
      case keyCodes.LEFT:
        $scope.ctrl.prevPhoto();
        break;

      case keyCodes.RIGHT:
        $scope.ctrl.nextPhoto();
        break;

      case keyCodes.ESC:
        !$scope.ctrl.isAlertVisible && $scope.ctrl.close();
        break;
      }
    });
  }

  this.close = function () {
    if (!angular.isNumber(this.crop)) {
      slideshow.hide();
    }
  };

  this.nextPhoto = function () {
    if (this.areButtonsDisabled) {
      return;
    }

    this.currentPhotoIndex = (this.currentPhotoIndex + 1 < this.photos.length) ? this.currentPhotoIndex + 1 : 0;
    this.currentPhoto = this.photos[this.currentPhotoIndex];
  };

  this.prevPhoto = function () {
    if (this.areButtonsDisabled) {
      return;
    }

    this.currentPhotoIndex = (this.currentPhotoIndex - 1 >= 0) ? this.currentPhotoIndex - 1 : this.photos.length - 1;
    this.currentPhoto = this.photos[this.currentPhotoIndex];
  };

  this.makeMain = function (photo) {
    if (this.areButtonsDisabled) {
      return;
    }

    this.areButtonsDisabled = true;

    photoModel.makeMain(photo)
      .then(() => {
        this.photos = photoModel.getValidPhotos();
        this.currentPhotoIndex = 0;
      })
      .finally(() => delete this.areButtonsDisabled);
  };

  this.rotate = function (photo, angle) {
    if (this.areButtonsDisabled) {
      return;
    }

    this.areButtonsDisabled = true;
    const newAngle = (photo.angle + angle + 360) % 360;

    photoModel.rotatePhoto(photo, newAngle)
      .finally(() => {
        delete this.areButtonsDisabled;
      });
  };

  this.delete = function (photo) {
    const alertConfig = {
      header: 'ALERTS.DELETE_PHOTO.CONTENT',
      buttons: [
        {
          label: 'ALERTS.DELETE_PHOTO.BUTTON_ACCEPT',
          action: 'accept',
          cssClass: 'Button--red'
        },
        {
          label: 'ALERTS.DELETE_PHOTO.BUTTON_DECLINE',
          action: 'decline',
          cssClass: 'Button--inverted'
        }
      ]
    };

    if (!(this.photos.length > 1 || !this.isGuide)) {
      alert.show({
        header: 'ALERTS.DELETE_LAST_PHOTO.HEADER',
        body: 'ALERTS.DELETE_LAST_PHOTO.CONTENT',
        buttons: [
          {
            label: 'ALERTS.DELETE_LAST_PHOTO.BUTTON',
            action: 'accept'
          }
        ]
      });
      return;
    }

    if (this.areButtonsDisabled) {
      return;
    }

    this.isAlertVisible = true;
    alert.show(alertConfig, { cssClass: 'Modal--blackBackdrop' })
      .then(() => {
        this.areButtonsDisabled = true;

        return photoModel.deletePhoto(photo);
      })
      .finally(() => {
        $timeout(() => {
          delete this.isAlertVisible;
        });
      })
      .then(() => {
        delete this.areButtonsDisabled;
        this.photos.splice(this.photos.indexOf(photo), 1);
        if (this.photos.length) {
          this.prevPhoto();
        } else {
          this.close();
        }
      })
      .catch(() => {
        delete this.areButtonsDisabled;
      });
  };

  documentEl.on('keyup', keyupHandler);

  $element.on('$destroy', function () {
    documentEl.off('keyup', keyupHandler);
  });
}



// WEBPACK FOOTER //
// ./app/src/common/slideshow/slideshow.ctrl.js